import RightPanel from '../common/RightPanel';
import useAgentsHome from './useAgentsHome';
import AgentsHomeWithDialogs from './AgentsHomeWithDialogs';
import { PanelEnvSelector } from '../pages/environments/connect-env/PanelEnvSelector';
import { useSelector } from 'react-redux';
import { selectDefaultCreationCrmOrgId } from '../../reducers/userInfoReducer';

const AgentsHomePanel = ({ closePanel }: { closePanel?: () => void }) => {
  const { isExpanded, isOpened } = useAgentsHome();
  const crmOrgId = useSelector(selectDefaultCreationCrmOrgId);

  return (
    <RightPanel isOpened={isOpened} isExpanded={isExpanded}>
      <PanelEnvSelector filterByEnvsUsedInCanvas />
      <AgentsHomeWithDialogs isPageView={false} closePanel={closePanel} key={crmOrgId} />
    </RightPanel>
  );
};

export default AgentsHomePanel;
